import { render, staticRenderFns } from "./PositionWarning.vue?vue&type=template&id=0651dd43&scoped=true"
import script from "./PositionWarning.vue?vue&type=script&lang=js"
export * from "./PositionWarning.vue?vue&type=script&lang=js"
import style0 from "./PositionWarning.vue?vue&type=style&index=0&id=0651dd43&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0651dd43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0651dd43')) {
      api.createRecord('0651dd43', component.options)
    } else {
      api.reload('0651dd43', component.options)
    }
    module.hot.accept("./PositionWarning.vue?vue&type=template&id=0651dd43&scoped=true", function () {
      api.rerender('0651dd43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/shared/PositionWarning.vue"
export default component.exports